import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { CallOutboundEditComponent } from './call-outbound-edit.component'

const CALL_OUTBOUND_EDIT_ROUTES: Routes = [{
    path: '', component: CallOutboundEditComponent
}];

export const CALL_OUTBOUND_EDIT_ROUTING  = RouterModule.forChild(CALL_OUTBOUND_EDIT_ROUTES);